export default function Chart() {
  return (
    <div className="chart-container">
      {/* <a
          target="_blank"
          href="https://www.dextools.io/app/bsc/pair-explorer/0xf8629846aa1c5003d8e053b74fecaf31c127c98c"
        >
          DEX TOOLS
        </a> */}
      <iframe
        src="https://charts.bogged.finance/0x4e6a510659d3d0F6897bbab3Db67DA0B3d001fB7"
        height="1000px"
        width="100%"
      ></iframe>
    </div>
  );
}
